// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__ieTEm","selected":"Chip_selected__98LD_"};